/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');
var makeFormReadOnly = require('common/util/makeFormReadOnly');

var tmplCOCEntityFormView = require('../templates/COCEntityFormView.hbs');
var AddressView = require('common/views/AddressView');

module.exports = Marionette.LayoutView.extend({
  template: tmplCOCEntityFormView,

  className: 'coc-entity-form-view',

  ui: {
    addressContainer: '.address-container',
    entityTypeId: '[name="entityTypeId"]',
    organizationTypeField: '.organization-type-field',
    organizationTypeSelect: '[name="organizationTypeId"]',
    websiteField: '.website-field'
  },

  regions: {
    addressContainer: '@ui.addressContainer'
  },

  events: {
    'change @ui.entityTypeId': 'onChangeEntityTypeId'
  },

  onBeforeShow: function() {
    var entity = this.model.get('entity');
    var viewMode = this.model.get('viewMode');
    var postalCode = null;
    var country = null;
    if (viewMode === 'view' || viewMode === 'edit') {
      postalCode = entity.postalCode;
      country = entity.country;
    }
    this.showChildView(
      'addressContainer',
      new AddressView({
        horizontal: false,
        startingCountry: null,
        startingPostalCode: postalCode,
        startingCounty: country,
        isRequired: true
      })
    );
    if (viewMode === 'view' || viewMode === 'edit') {
      Syphon.deserialize(this, entity);
      this.onChangeEntityTypeId();
    }
    if (viewMode === 'view') {
      makeFormReadOnly(this.$el);
    }
  },

  onChangeEntityTypeId: function() {
    var formData = this.getFormData();
    if (formData.entityTypeId === '1' || !formData.entityTypeId || formData.entityTypeId === '') {
      this.ui.organizationTypeField.hide().removeClass('required');
      this.ui.organizationTypeSelect.attr('data-parsley-required', false);

      this.ui.websiteField.hide();
    } else {
      this.ui.organizationTypeField.show().addClass('required');
      this.ui.organizationTypeSelect.attr('data-parsley-required', true);

      this.ui.websiteField.show();
    }
  },

  getFormData: function() {
    var formData = Syphon.serialize(this);
    return formData;
  }
});
